import { Outlet } from 'react-router-dom';

export const FigmaPluginAuth = () => (
  <Outlet />
);
